import styled from "styled-components";

export const IndicatorDataDiv = styled.div`
  margin: 20px auto;
  padding: 10px;
  width: 100%;
  max-width: 860px;
  background-color: #ccc;
  border-radius: 5px;
  @media (max-width: 910px) {
    width: 85%;
  }
`;
export const IndicatorDataText = styled.p`
  font-size: 18px;
  color: #fff;
`;
export const ScreenshotContainer = styled.div`
  margin: auto;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  background-color: #e3e3e3;
`;
export const EvaluationDataDiv = styled.div`
  margin: 0 auto 5px;
  padding: 2px;
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
`;
export const Row = styled.div`
  width: 100%;
  display: flex;
  background-color: ${({ background }) => background && background};
  border-bottom: ${({ borderBottom }) => borderBottom && borderBottom};
`;
export const Box = styled.div`
  padding: 5px 10px 5px 16px;
  width: ${({ width }) => width && width};
  min-height: 40px;
  display: flex;
  align-items: ${({ alignItems }) => (alignItems ? alignItems : "center")};
  background-color: ${({ background }) => background && background};
  border-left: ${({ borderLeft }) => borderLeft && borderLeft};
`;
export const Text = styled.p`
  color: #000;
  font-size: 14px;
  font-weight: ${({ strong }) => (strong ? "600" : "400")};
`;
